<template>
  <div class="editable-div" @click="focus()">
    <div v-show="placeholder && !value" class="placeholder">
      {{ placeholder }}
    </div>
    <div
      ref="el"
      class="inner"
      :contenteditable="editable"
      v-on="forwardedListeners"
      @input.stop="$emit('input', $event.target.innerText)"
      @keydown.esc="blur"
      @click.stop
    ></div>
  </div>
</template>

<style scoped>
.editable-div .inner {
  margin: -6px -6px;
  padding: 4px 6px;

  outline: none;
  border-radius: var(--rounding-smaller);
  border-bottom: solid 2px transparent;
  border-top: solid 2px transparent;
  background: var(--bg-color-hover);

  white-space: pre-wrap;
}
.editable-div .inner:focus {
  border-bottom: solid 2px var(--link-color);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.editable-div .inner[contenteditable="false"] {
  pointer-events: none;
}
.editable-div .inner[contenteditable="true"] {
  /* This should fix the contenteditable field on iOS7+:
     * https://stackoverflow.com/questions/21295698/html5-contenteditable-attribute-not-working-properly-on-ios7-mobile-safari
     */
  -webkit-user-select: text;
  user-select: text;
}
.placeholder {
  position: absolute;
  top: auto; /* Adjust for parent padding */
  left: 0;
  white-space: nowrap;
  opacity: 0.38;
}
input {
  /* Just make sure it's never visible */
  position: absolute;
  margin: 0;
  padding: 0;
  right: 200%;
}
</style>

<script>
export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "",
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    forwardedListeners() {
      // We override the input event with our custom one, so this one should be
      // not forwarded.
      const { input, ...other } = this.$listeners;
      return other;
    },
  },
  methods: {
    select() {
      this.$refs.el.focus();
      window.getSelection().selectAllChildren(this.$refs.el);
    },
    focus() {
      // Calling .focus() is necessary to trigger the soft keyboard on
      // Android. However, it places the caret at the beginning of the
      // div, so we need to adjust the selection then.
      this.$refs.el.focus();
      window.getSelection().selectAllChildren(this.$refs.el);
      window.getSelection().collapseToEnd();
    },
    blur() {
      this.$refs.el.blur();
    },
  },
  watch: {
    value(newValue, oldValue) {
      newValue = String(newValue);
      if (this.$refs.el.innerText != newValue) {
        this.$refs.el.innerText = newValue;
      }
    },
  },
  mounted() {
    this.$refs.el.innerText = String(this.value);
  },
};
</script>
